export default __webpack_public_path__ + "static/kitchen-area-e22f22374dbde8f74614b0da2a387b84.jpeg";